var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonsieurAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12579_30084)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_12579_30084)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1331 23.2005V24.8005C24.1331 26.9339 27.1998 27.8672 27.1998 27.8672C27.1998 27.8672 23.6665 30.5339 19.9998 30.5339C16.3331 30.5339 12.7998 27.8672 12.7998 27.8672C12.7998 27.8672 15.8906 26.9339 15.8665 24.8005C15.8423 22.6672 15.8585 21.4139 15.8423 17.7589C13.9314 15.282 14.0541 13.6196 15.099 12.4505C18.5998 8.53387 28.1331 9.86721 28.1331 9.86721C28.1331 9.86721 29.0227 19.4663 26.9998 22.2672C26.1331 23.4672 24.1331 23.2005 24.1331 23.2005Z",
    fill: "url(#paint0_linear_12579_30084)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1335 23.2016C21.2001 22.8682 19.4668 21.6016 19.4668 21.6016C20.5611 23.2206 22.2289 24.3642 24.1335 24.8016V23.2016Z",
    fill: "#FFDBC9"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 31.908C35.2693 34.4889 36 40.4413 36 40.4413H4C4 40.4413 4.73093 34.4883 6 31.908C7.26907 29.3277 14.68 26.9345 14.68 26.9345C16.1084 29.8669 23.9477 29.8669 25.3161 26.9336C25.3161 26.9336 32.7307 29.3271 34 31.908Z",
    fill: "url(#paint1_linear_12579_30084)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4668 37.0659C19.4668 36.9604 19.4981 36.8573 19.5567 36.7696C19.6153 36.6819 19.6986 36.6135 19.796 36.5732C19.8935 36.5328 20.0007 36.5222 20.1042 36.5428C20.2076 36.5634 20.3027 36.6142 20.3773 36.6888C20.4518 36.7634 20.5026 36.8584 20.5232 36.9618C20.5438 37.0653 20.5332 37.1725 20.4929 37.27C20.4525 37.3674 20.3841 37.4507 20.2964 37.5093C20.2087 37.5679 20.1056 37.5992 20.0001 37.5992C19.8587 37.5992 19.723 37.543 19.623 37.443C19.523 37.343 19.4668 37.2073 19.4668 37.0659ZM19.4668 34.3992C19.4668 34.2937 19.4981 34.1906 19.5567 34.1029C19.6153 34.0152 19.6986 33.9469 19.796 33.9065C19.8935 33.8661 20.0007 33.8556 20.1042 33.8761C20.2076 33.8967 20.3027 33.9475 20.3773 34.0221C20.4518 34.0967 20.5026 34.1917 20.5232 34.2952C20.5438 34.3986 20.5332 34.5059 20.4929 34.6033C20.4525 34.7008 20.3841 34.7841 20.2964 34.8427C20.2087 34.9013 20.1056 34.9326 20.0001 34.9326C19.8587 34.9326 19.723 34.8764 19.623 34.7763C19.523 34.6763 19.4668 34.5407 19.4668 34.3992ZM19.4668 31.7326C19.4668 31.6271 19.4981 31.524 19.5567 31.4362C19.6153 31.3485 19.6986 31.2802 19.796 31.2398C19.8935 31.1994 20.0007 31.1889 20.1042 31.2095C20.2076 31.23 20.3027 31.2808 20.3773 31.3554C20.4518 31.43 20.5026 31.525 20.5232 31.6285C20.5438 31.732 20.5332 31.8392 20.4929 31.9367C20.4525 32.0341 20.3841 32.1174 20.2964 32.176C20.2087 32.2346 20.1056 32.2659 20.0001 32.2659C19.8587 32.2659 19.723 32.2097 19.623 32.1097C19.523 32.0097 19.4668 31.874 19.4668 31.7326Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4874 13.7615C17.0634 13.3974 16.5482 13.1522 15.82 13.5306C14.0934 14.427 15.4001 17.867 16.9334 17.867C17.3334 17.867 17.5324 19.1233 15.7514 20.0003C15.7514 18.6003 13.6181 15.1337 13.4314 11.9774C11.2848 11.1781 11.8181 7.9798 13.2918 7.9798C13.0566 5.04807 17.7514 3.53367 19.5693 5.2162C21.4181 3.00034 26.0848 4.13367 26.3665 6.05607C29.5754 4.34314 31.6848 9.267 28.6801 11.1785C27.4437 11.9651 24.5514 12.2645 20.3764 12.2645C19.7461 12.2645 19.393 12.421 19.5693 13.2003C19.9105 14.7105 19.1184 15.6617 17.4874 13.7615Z",
    fill: "url(#paint2_linear_12579_30084)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12579_30084",
    x1: 20.5639,
    y1: 9.64844,
    x2: 20.5639,
    y2: 30.5339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDCC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12579_30084",
    x1: 20,
    y1: 26.9336,
    x2: 20,
    y2: 40.4413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#806A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#665654"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12579_30084",
    x1: 21.0646,
    y1: 20.0003,
    x2: 21.0646,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6864E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67240"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12579_30084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_12579_30084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonsieurAvatar);
export default __webpack_public_path__ + "static/media/monsieurAvatar.9819a3cbf2a8a87a8cacf43a887a072c.svg";
export { ForwardRef as ReactComponent };